export const COLLAPSE_KEY = Symbol("collapse");
